export function adminReducer(state = null, action) {
  switch (action.type) {
    case "SINGLE_ORDER":
      return action.payload;
    case "SINGLE_RETAIL_CLIENT":
      return action.payload;
    case "SINGLE_B2B_CLIENT":
      return action.payload;
    default:
      return state;
  }
}
